exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#thankyou,#welcome{position:absolute;top:50%;left:50%;transform:Translate(-50%,-50%);min-height:400px;width:800px}#dashboard{position:absolute;top:10px;right:10px;height:calc(100% - 20px);width:300px}#choice{position:absolute;bottom:20px;left:50%;transform:translateX(-50%);width:800px;height:200px}.player-container{height:680px}#gameContainer,.ui-container{width:100%;height:100%}.ui-container{transform:TranslateY(-100%);display:relative}.option{width:calc(50% - 4px);margin-bottom:5%}.start-button{width:200px;bottom:0;right:20px}.next-button,.start-button{position:absolute;height:40px}.next-button{width:calc(100% - 20px);bottom:10px;right:50%;transform:TranslateX(50%)}.inactive{opacity:.1}.active:hover{filter:brightness(1.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56a81204","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/player.vue
// module id = 25
// module chunks = 0